import {h, render, Component} from 'preact';
import fs from 'fs';
import App from "./components/App";

if(!window.SPRINGIFY_WHEEL_APP_MOUNTED){
    window.SPRINGIFY_WHEEL_APP_MOUNTED = true;
    const css = fs.readFileSync('dist/Widget.css', "utf8"); // <-- The css reader
    const style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
    render(<App/>, document.body);
}

